import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../../components/Layout/MainLayout';
import DataCenterCard from '../../../components/Dashboard/DataCenterCard';
import { RegularRDCIcon, RDEIcon, BackIcon } from '../../../components/Dashboard/DataCenterIcons';
import '../../../assets/styles/RDCPage.css';
import { ROUTES } from '../../../utils/constants';

const RDCPage: React.FC = () => {
  const navigate = useNavigate();
  const rdcTypes = [
    {
      id: 'regular-rdc',
      title: 'Regular RDC',
      icon: <RegularRDCIcon />,
      path: ROUTES.RDC_REGULAR,
    },
    {
      id: 'rde',
      title: 'RDE',
      icon: <RDEIcon />,
      path: ROUTES.RDC_RDE,
    },
  ];

  return (
    <MainLayout>
      <div className="rdc-page">
        {/* Back Button */}
        <div className="rdc-back-button-container">
          <button
            onClick={() => navigate(ROUTES.DASHBOARD)}
            className="rdc-back-button"
          >
            <BackIcon />
            Back
          </button>
        </div>

        {/* Main Content */}
        <div className="rdc-grid">
          {rdcTypes.map((type) => (
            <DataCenterCard
              key={type.id}
              title={type.title}
              icon={type.icon}
              onClick={() => navigate(type.path)}
            />
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default RDCPage;
